import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { pick } from 'underscore';
import { getDisplayOptionsToUse } from 'AppSrc/core/components/forms/data/get-display-options-to-use';
import { SectionCompletionReviewSummary } from 'AppSrc/core/components/forms/form-base-components/summary-components/section-completion-review-summary';
import {
  VF_MODAL,
} from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import {
  // object mapping strings to components for each form field type
  formFieldTypes,
  silentErrorsAreViewable,
} from '../../form-section-utility-functions';
import {
  formDataShape,
  errorsPropShape,
} from '../../form-base-components/data-structure/v-f-proptypes';
import {
  SectionError,
} from '../../section-error';
import {
  formikTouchedShape,
} from '../../form-base-components/data-structure/formik-proptypes';
import {
  getSectionFieldIds,
} from './form-utility-functions';

const SectionErrorsMapping = {
  POST_CHANGE_QUESTIONNAIRE: 'Please ensure you have answered all the questions in the Post Change Review.',
  CI_UNAVAILABILITY: 'Please enter Actual start and end date/time.',
  ACTUAL_CHANGE_WINDOW: 'Please enter Actual start and end date/time.',
};
class SectionFields extends PureComponent {

  render() {
    const {
      fields,
      formData,
      errors,
      subSectionId,
      touched,
      summaryRead,
      readOnly,
    } = this.props;

    const {
      network,
    } = formData;

    let ViewableErrors;
    let sectionErrors;
    if (errors && touched) {
      sectionErrors = pick(errors, getSectionFieldIds(fields));
      ViewableErrors = silentErrorsAreViewable(sectionErrors, touched);
    }

    return (
      <div>
        {
          summaryRead ? (
            <SectionCompletionReviewSummary
              formSection={fields}
              formData={formData.dataByFormSectionId.COMPLETION_REVIEW.dataByFieldId}
              selectedNetwork={network}
            />
          ) : (
            fields.map((field, i) => {
              if (!field.shouldRender) {
                return null;
              }

              const {
                disabledFieldOptions,
                componentData,
                optional,
                updateValue,
              } = field;

              const {
                id,
                vFParams,
                fieldType,
              } = componentData;

              const fieldTypeIsModal = fieldType === VF_MODAL;

              const displayOptions = getDisplayOptionsToUse({
                componentData,
                selectedNetwork: network,
              });

              return (
                <Field
                  key={id}
                  name={id}
                  summaryRead={summaryRead}
                  optional={optional}
                  displayOptions={displayOptions}
                  disabledFieldOptions={disabledFieldOptions}
                  readOnly={readOnly}
                  vFParams={vFParams}
                  component={formFieldTypes[fieldType]}
                  updateValue={updateValue}
                  outerFormData={fieldTypeIsModal ? formData : null}
                />
              );
            })
          )
        }
        {
          ViewableErrors && (
            <SectionError errorMsg={SectionErrorsMapping[subSectionId]} />
          )
        }
      </div>
    );
  }
}

SectionFields.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object),
  formData: formDataShape,
  errors: errorsPropShape,
  subSectionId: PropTypes.string,
  touched: formikTouchedShape,
  summaryRead: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export { SectionFields };
